import type { AlunoFaltasConsecutivasData, AlunoRiscoData } from './gestor.types';

export type BuscaAtivaStatus =
  | 'NOVO_ALERTA'
  | 'CONTATO_PENDENTE'
  | 'AGUARDANDO_FAMILIA'
  | 'CAUSA_IDENTIFICADA'
  | 'ENCAMINHADO'
  | 'RETORNO_COMBINADO'
  | 'EM_OBSERVACAO'
  | 'RECUPERADO'
  | 'EVASAO_CONFIRMADA';

export type NivelRisco = 'CRITICO' | 'ALTO' | 'MEDIO' | 'OBSERVACAO';

export interface CasoBuscaAtiva {
  id?: string;
  escola_id: string;
  aluno_id: string;
  status: BuscaAtivaStatus;
  nivel_risco: NivelRisco;
  score_risco: number;
  motivos_risco: string[];
  barreira_principal?: string | null;
  responsavel_user_id?: string | null;
  responsavel_nome?: string | null;
  proxima_acao?: string | null;
  proximo_follow_up?: string | null;
  primeiro_contato_em?: string | null;
  data_prevista_retorno?: string | null;
  retornou_em?: string | null;
  recuperado_em?: string | null;
  fechado_em?: string | null;
  motivo_fechamento?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface ResumoBuscaAtiva {
  contatado: boolean;
  ultimoContato?: string;
  totalContatos: number;
  ultimoStatus?: string;
  historico: Array<{
    data_contato: string;
    created_at?: string;
    status_funil?: string;
    forma_contato: string;
    justificativa_faltas: string;
    monitor_responsavel: string;
    template_id?: string;
    resultado_contato?: string;
  }>;
}

export interface PresencaBuscaAtiva {
  data_chamada: string;
  presente: boolean;
  falta_justificada: boolean;
}

export type AlunoBaseBuscaAtiva = AlunoRiscoData | AlunoFaltasConsecutivasData;

export interface AlunoCasoBuscaAtiva {
  aluno_id: string;
  aluno_nome: string;
  turma_nome: string;
  telefone: string | null;
  nome_responsavel?: string | null;
  isConsecutiva: boolean;
  total_faltas: number;
  faltas_consecutivas: number;
  score: number;
  nivel: NivelRisco;
  motivos: string[];
  followUpVencido: boolean;
  caso: CasoBuscaAtiva;
  resumo?: ResumoBuscaAtiva;
  presencas: PresencaBuscaAtiva[];
}

export const STATUS_LABELS: Record<BuscaAtivaStatus, string> = {
  NOVO_ALERTA: 'Novo alerta',
  CONTATO_PENDENTE: 'Contato pendente',
  AGUARDANDO_FAMILIA: 'Aguardando família',
  CAUSA_IDENTIFICADA: 'Causa identificada',
  ENCAMINHADO: 'Encaminhado',
  RETORNO_COMBINADO: 'Retorno combinado',
  EM_OBSERVACAO: 'Em observação',
  RECUPERADO: 'Recuperado',
  EVASAO_CONFIRMADA: 'Evasão confirmada',
};

export const BARREIRAS_BUSCA_ATIVA = [
  'Saúde',
  'Transporte',
  'Trabalho ou rotina familiar',
  'Dificuldade de aprendizagem',
  'Conflito ou bullying',
  'Cuidado de familiar',
  'Mudança de endereço',
  'Vulnerabilidade socioeconômica',
  'Outra',
] as const;
